<template>
    <router-view />
</template>

<script>
import { Tooltip } from 'bootstrap';

export default {
    mounted() {
		new Tooltip(document.body, {
			selector: "[data-bs-toggle='tooltip']",
		})
	},
};
</script>
